import React, { useContext, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Page } from "components/common";
import { Trans } from "react-i18next";
import ListEInvoices from "pages/Xero/AccountsReceivable/Portal/ListInvoices2";
import ListCreditNotes from "pages/Xero/AccountsReceivable/ListCreditNotes";
import EmployeeContext from "contexts/EmployeeContext";

export const EInvoicePortal = ({ client, match, ...props }) => {
  const { employee } = useContext(EmployeeContext);
  const [activeTab, setActiveTab] = useState('1');
  if (!employee || (employee && !(employee.invitation_type === 'e-invoice'))) return null;
return (
  <Page>
   <div className='inv-tabs'>
      <Nav tabs className='mb-2'>
        <NavItem>
          <NavLink className={activeTab == '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
            <Trans>Sales invoices</Trans>

        </NavLink>
        </NavItem>
        <NavItem>
          <NavLink className={activeTab == '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>

            <Trans>Sales Credit Notes</Trans>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <ListEInvoices match={`${match.url}/accounts_receivable/invoices`} />
        </TabPane>
        <TabPane tabId="2">
            <ListCreditNotes match={`${match.url}/credit_notes`} allowCreate={false}/>
        </TabPane>
      </TabContent>
    </div>
  </Page>
 );
}
export default EInvoicePortal;
